import React, {Component} from 'react';
import {Button, Popup, Form, Icon, Grid, Header, Image, Label, Message, Segment,Dropdown} from "semantic-ui-react";
import moment from 'moment';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import {getInspectionByInspectionId, updateInspectionByID} from '../../data/inspection_api';
import {COMPANY_API_URL, INSPECTION_API_URL, PROPERTY_VISIT_API_URL} from "../../constants/api_routes";
import Loader from "../universal/loader";
import {DropzoneComponent} from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import InspectionContainer from "../../containers/inspection_container";
import * as fileIcon from "../../assets/fileIcon.png";
import {getAgentsOfCompany} from "../../data/user_api";
import { getPropertyDetails } from "../../data/user_api";
import ViewPropertyDetails from "../properties/view_property_details"
import { getPVClerks } from '../../data/user_api';
import { getPropertyVisitsByDate } from '../../data/dashboard_api';


class UpdateInspection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            action: "view",
            isFetching: true,
            jobType: undefined,
            invoiceIsDefault: true,
            displayAdditionalInvoiceOption: false,
            reportType: undefined,
            inspectionDate: moment(),
            inspectionTime: moment(),
            inspectionStartTime: undefined,
            inspectionEndTime: undefined,
            RequestedTime: '3',
            showCustomTimeSelect: 'none',
            inspectionId: undefined,
            inspectionDetails: [],
            error: false,
            errorInfo: undefined,
            infoMessage: undefined,
            attachments: [],
            maxNumberOfFilesExceeded: false,
            notes: " ",
            comments: " ",
            additionalChanged: false,
            dateValid:true,
            defaultEndTime:undefined,
            timeValid:true,
            reportTypeValid:true,
            agentListOptions:[],
            agentValid:true,
            assignedAgent:undefined,
            numberOfBedroom:undefined,
            furnishingType:'0',
            clerkFeeError:false,
            invoiceFeeError:false,
            showPropertyDetails: false,
            fetchingPropertyDetails : true,
            propertyDetails:undefined,
            clerkOptions:undefined,
            selectedClerk:undefined,
            filteredPVs:[],
            selectedClerkObject:undefined
        }
    }

    componentWillMount() {
        if(this.props.userRole === 'admin' || this.props.userRole === 'agent'){
            this.getInspectionDetails().then(() => {
                this.refreshPVs()
            });
        }
        else {
            // this.props.history.pop();
        }

    }
    

    checkClerkEndDate = () =>{
        if(this.state.selectedClerkObject && this.state.selectedClerkObject.end_date) {
                let inspectionDate;

                if (this.state.inspectionDate instanceof Date) {
                    inspectionDate = moment(this.state.inspectionDate);
                } else {
                    inspectionDate = moment(this.state.inspectionDate, "DD-MM-YYYY");
                }
            if(moment(this.state.selectedClerkObject.end_date).isBefore(inspectionDate)){
                window.alert(`The inspection date (${moment(this.state.inspectionDate).format("DD-MM-YYYY")}) is after the assigned clerk's end date (${moment(this.state.selectedClerkObject.end_date).format("DD-MM-YYYY")})`)
            }
        }
    }
    refreshPVs = async ()=>{
        this.setState({filteredPVs:[]})
        const response = await getPropertyVisitsByDate(PROPERTY_VISIT_API_URL, this.state.inspectionDate,this.state.inspectionDate);

            let filteredPVs = response
                .filter(
                    visit => visit.visit_date != null &&
                            visit.user_id === this.state.selectedClerk
                )
                .sort((a, b) => a.status.localeCompare(b.status));

            this.setState({ filteredPVs: [...filteredPVs] });
    }
    getPropertyDetails = async () => {
            let propertyDetails = await getPropertyDetails(this.props.selectedObject.id)
            this.setState({propertyDetails: propertyDetails,fetchingPropertyDetails:false})
        }

    getInspectionDetails = async () => {
        const response = await getInspectionByInspectionId(this.props.selectedObject.id);
        const furnishing = ["furnished","unfurnished","semifurnished"];
        if (response.success) {
            if(response.inspection['company_id']){
                this.getAgentList(response.inspection['company_id']).then();
            }
            this.setState({isFetching: false, inspectionDetails: response.inspection});
            this.setState({
                jobType: this.state.inspectionDetails['inspection_type'],
                invoiceIsDefault: this.state.inspectionDetails['default_invoice'],
                reportType: this.state.inspectionDetails['report_type'],
                displayAdditionalInvoiceOption: !this.state.inspectionDetails['default_invoice'],
                inspectionDate: moment(this.state.inspectionDetails['inspection_start_time'], 'YYYY-MM-DD HH:mm').format("DD-MM-YYYY"),
                inspectionStartTime: moment(this.state.inspectionDetails['inspection_start_time'], 'YYYY-MM-DD HH:mm').format("YYYY-MM-DD HH:mm"),
                inspectionEndTime: moment(this.state.inspectionDetails['inspection_end_time'], 'YYYY-MM-DD HH:mm').format("YYYY-MM-DD HH:mm"),
                defaultEndTime: moment(this.state.inspectionDetails['inspection_end_time'], 'YYYY-MM-DD HH:mm'),
                assignedAgent:this.state.inspectionDetails['agent_profile_id'],
                numberOfBedroom:this.state.inspectionDetails['property_size']?this.state.inspectionDetails['property_size']:'0',
                furnishingType:furnishing.indexOf(this.state.inspectionDetails['furnishing_type']),
                notes:this.state.inspectionDetails['notes'],
                comments:this.state.inspectionDetails['conclusion_notes'],
                selectedClerk:this.state.inspectionDetails['user'] ? this.state.inspectionDetails['user']['id'] : undefined,
                selectedClerkObject:this.state.inspectionDetails['user'] ? this.state.inspectionDetails['user'] : undefined
            });
            this.getClerkList()
        }
        else {
            this.setState({error: true, errorInfo: "Something Went wrong, Try again later!!"});
        }
    };


    getClerkList = async () =>{
        let clerkOptions = []
         getPVClerks().then((response) => {
            response.clerk_profiles.map((clerk) => {
            let clerkObj = {
                value: clerk.user_id,
                text: clerk.name,
                key: clerk.user_id,
                end_date:clerk.end_date
                }
                clerkOptions.push(clerkObj)
            }
        )
        this.setState({ clerkOptions: clerkOptions });
      });
  
    }
    getAgentList = async (companyId) => {
        const agentList = await getAgentsOfCompany(COMPANY_API_URL, companyId);
        let agentOptions = [];
        for (let i = 0; i < agentList.length; i++) {
            let obj = {
                key: agentList[i].id,
                text: agentList[i].name,
                value: agentList[i].id
            };
            agentOptions.push(obj);
        }
        this.setState({agentListOptions: agentOptions});
    };

    renderImages = (images) => {
        return images.map((image, i) => <Image key={i} as='a' target='_blank'
                                               href={image.file}
                                               src={image['content_type'] && image['content_type'].match(/image/i)?image.file:fileIcon}/>);
    };
    onStartChange = (value) => {
        if(value) {
            this.setState({inspectionStartTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(value.get('hour')).minute(value.get('minute')).format("YYYY-MM-DD HH:mm"),inspectionEndTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(value.get('hour')).minute(value.get('minute')).add(0.5,"hour").format("YYYY-MM-DD HH:mm"),defaultEndTime:moment(this.state.inspectionDate, "YYYY-MM-DD").hour(value.get('hour')).minute(value.get('minute')).add(0.5,"hour")});
        }
        else {
            this.setState({inspectionStartTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(8).minute(0).format("YYYY-MM-DD HH:mm"),inspectionEndTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(17).minute(0).format("YYYY-MM-DD HH:mm"),defaultEndTime:moment(this.state.inspectionDate, "YYYY-MM-DD").hour(17).minute(0)});
        }
    };

    onEndChange = (value) => {
        if(value) {
            this.setState({inspectionEndTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(value.get('hour')).minute(value.get('minute')).format("YYYY-MM-DD HH:mm"),defaultEndTime:value});
        }
        else {
            this.setState({inspectionEndTime: moment(this.state.inspectionDate, "DD-MM-YYYY").hour(17).minute(0).format("YYYY-MM-DD HH:mm"),defaultEndTime:moment(this.state.inspectionDate, "DD-MM-YYYY").hour(17).minute(0)});
        }
    };

    disabledHours = () => {
        return [0,1,2,3,4,5,6];
    };

    handleSubmit = (e) => {
        if(!(this.state.inspectionStartTime && this.state.inspectionEndTime)){
            this.setState({timeValid:false});
            return null;
        }
        if(this.state.reportType === undefined || this.state.reportType == "undefined") {
            this.setState({reportTypeValid:false})
            return  null
        }
        this.setState({updating:true});
        const formData = new FormData(e.target);
        formData.append("property_id", this.state.inspectionDetails['property_id']);
        formData.append("report_type",this.state.reportType?this.state.reportType:undefined);
        formData.append("agent_profile_id", this.state.assignedAgent);
        formData.append("inspection_type", this.state.jobType);
        formData.append("inspection_start_time", moment(this.state.inspectionStartTime).format("YYYY-MM-DD HH:mm"));
        formData.append("inspection_end_time", moment(this.state.inspectionEndTime).format("YYYY-MM-DD HH:mm"));
        formData.append("default_invoice", this.state.invoiceIsDefault ? "true" : "false");
        formData.append("property_size", this.state.numberOfBedroom);
        formData.append("furnishing_type", this.state.furnishingType);
        if(this.state.selectedClerk) {
            formData.append('selected_clerk',this.state.selectedClerk)
        }
        this.updateInspection(this.state.inspectionDetails.id, formData).then(() => {
            this.setState({updating:false});
        });
        // if (this.state.additionalChanged) {
        //     this.setState({updating:true});
        //     const formData = new FormData();
        //     formData.append("inspection_id", this.state.inspectionDetails.id);
        //     formData.append("notes", this.state.notes);
        //     formData.append("comments", this.state.comments);
        //     this.props.updateInspectionWithAdditionalNotes(INSPECTION_API_URL, formData, this.additionalDetailsAddedCallBack);
        // }
    };

    checkFeeValidity = async (feeType,feeString) => {
        let isValid = (feeString =="" || feeString.toLowerCase().includes("total") || feeString.toLowerCase().includes("extra"))
        if (feeType == "clerk"){
            this.setState({clerkFeeError:!isValid})
        } else
        {this.setState({invoiceFeeError:!isValid})}
    }

    updateInspection = async (propertyId, formData) => {
        const response = await updateInspectionByID(INSPECTION_API_URL, propertyId, formData);
        if (response.success) {
            this.setState({infoMessage: "Successfully Updated Inspection"});
            setTimeout(() => {
                this.setState({infoMessage: undefined})
            }, 3000);
        }
    };

    removingFile = (file) => {
        let attachments = this.state.attachments;
        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        return attachments;
    };

    preloadImages = (dropzone) => {
        (this.state.inspectionDetails['inspection_attachments'] || []).forEach(function (i) {
            const name = i.id;
            const file = {url: i['file'], name: name, size: 1000000, id: name};
            const imageUrl = i['file'];

            file['serverId'] = name;
            file['accepted'] = true;
            file['status'] = 'success';
            file['upload'] = {
                progress: 100,
                total: 100000,
                bytesSent: 100000
            };
            dropzone.files.push(file);

            dropzone.emit("addedfile", file);
            if(i['content_type'] != null && i['content_type'].match(/image/i)){
                dropzone.emit("thumbnail", file, imageUrl);
            }
            else {
                dropzone.emit("thumbnail",file,fileIcon);
            }
            dropzone.emit("complete", file);
        });
    };

    additionalDetailsAddedCallBack = (response) => {
        if (response.success) {
            this.setState({success: true, infoMessage: "Successfully Updated Inspection", additionalChanged: false,updating:false});
            setTimeout(() => {
                this.setState({infoMessage: undefined})
            }, 10000);
        }
        this.setState({updating:false});
    };

    render() {
        const furnishing = ["furnished","unfurnished","semifurnished"];
        const user = this.state.currentUser;
        const furnishOptions = [
            {key: '1', text: 'Furnished', value: '0'},
            {key: '2', text: 'Part-Furnished', value: '2'},
            {key: '3', text: 'Un-Furnished', value: '1'},
        ];

        const bedRoomOptions = [
            {key: '1', text: 'Studio', value: 'studio'},
            {key: '2', text: '1 Bedroom', value: '1'},
            {key: '3', text: '2 Bedroom', value: '2'},
            {key: '4', text: '3 Bedroom', value: '3'},
            {key: '5', text: '4 Bedroom', value: '4'},
            {key: '6', text: '5 Bedroom', value: '5'},
            {key: '7', text: '6 Bedroom', value: '6'},
            {key: '8', text: '7 Bedroom', value: '7'},
            {key: '9', text: '8 or Above Bedroom', value: '8 & Above'},
        ];

        const selectedInspection = this.state.inspectionDetails;
        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};
        const djsConfig = {autoProcessQueue: false, addRemoveLinks: true, maxFiles: 3};
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                this.preloadImages(dropzone);
            },
            addedfile: (file) => {
                if(dropZone.files.length < 4){
                    const formData = new FormData();
                    if (file.upload) {
                        formData.append("inspection_id", selectedInspection.id);
                        if(this.state.notes){
                            formData.append("notes", this.state.notes);
                        }
                        else{
                            formData.append("notes"," ");
                        }
                        if(this.state.comments){
                            formData.append("comments", this.state.comments);
                        }
                        else {
                            formData.append("comments", " ");
                        }
                        formData.append("attachments[][file]", file);
                        this.setState({updating:true});
                        this.props.updateInspectionWithAdditionalNotes(INSPECTION_API_URL, formData, this.additionalDetailsAddedCallBack);
                    }
                }
            },
            removedfile: (file) => {
                this.setState({attachments: this.removingFile(file)});
                if (file.id) {
                    this.props.deleteInspectionAttachment(file.id);
                }
            },
            maxfilesexceeded: (file) => {
                dropZone.removeFile(file);
                this.setState({maxNumberOfFilesExceeded: true});
                setTimeout(() => {
                    this.setState({maxNumberOfFilesExceeded: false})
                }, 10000)
            }
        };

        const jobTypeOptions = [
            {key: 1, text: 'CI', value: 'ci'},
            {key: 2, text: 'CO', value: 'co'},
            {key: 3, text: 'INV/CI', value: 'inv/ci'},
            {key: 4, text: 'INV', value: 'inv'},
            { key: 5, text: 'PV', value: 'pv' },
            {key: 6, text: 'REV', value: 'rev'},
            {key: 7, text: 'CLN', value: 'cln'},
            {key: 8, text: 'SNG', value: 'sng'}
        ];

        const timeOptions = [
            {key: 0, text: 'Anytime', value: '0'},
            {key: 1, text: 'Anytime AM', value: '1'},
            {key: 2, text: 'Anytime PM', value: '2'},
            {key: 3, text: 'Custom Time', value: '3'}
        ];

        const handleDateRangeSelection = (e, option) => {
            switch (option.value) {
                case '0':
                    setDateTimes(option.value, 8, 18);
                    break;
                case '1':
                    setDateTimes(option.value, 8, 12);
                    break;
                case '2':
                    setDateTimes(option.value, 12, 18);
                    break;
                default:
                    setDateTimes(option.value, 8, 18);
            }

        };

        const setDateTimes = (requestedSlot, startTime, endTime) => {
            this.setState({
                RequestedTime: requestedSlot,
                inspectionStartTime: moment(this.state.inspectionDate,"DD-MM-YYYY").hour(startTime).minute(0).format("YYYY-MM-DD HH:mm"),
                inspectionEndTime: moment(this.state.inspectionDate,"DD-MM-YYYY").hour(endTime).minute(0).format("YYYY-MM-DD HH:mm")
            });
        };

        const timeFormat = 'HH:mm';

        const reportTypeOptions = [
            {key: 1, text: 'Hinch Standard', value: 'standard'},
            {key: 2, text: 'Custom - Upload File', value: 'custom'},
            {key: 3, text: 'New', value: 'new'}
        ];
        const reportTypeOptionsCO = [
            {key: 1, text: 'Hinch Standard', value: 'standard'},
            {key: 2, text: 'Custom - Upload File', value: 'custom'},
            { key: 3, text: 'New - Other Template', value: 'other' }
        ];
        const reportTypeOptionsPV = [
            {key: 1, text: 'Custom - Upload File', value: 'custom'}
        ];
        const mapStatus = ['pending', 'scheduled', 'confirmed', 'processing', 'submitted', 'completed', 'request_abort', 'aborted', 'request_cancel', 'cancelled'];
        const agentAccessRestricted = this.props.userRole === 'agent' || mapStatus.indexOf(selectedInspection['status']) > 5;
        
        return (
            <div style={{width: '97%%', margin: 'auto'}}>
                {this.state.updating && <Loader save={true}/>}
                <Form onSubmit={this.handleSubmit}>
                    <Header as='h2' content="Update Inspection Details" textAlign="center"/>
                    {this.state.isFetching && <Loader contain={true}/>}
                    {!this.state.isFetching && <Segment>
                        <div>
                            <div className="pad-bottom">
                              {this.state.filteredPVs.length > 0 && <Message color="red"><Message.Header>Property Visits Detected</Message.Header>Property Visits detected for this clerk and date
                                 <ul>
                              {this.state.filteredPVs.map(visit=>{
                                return <li key={visit.id}>{` ${visit.status.toUpperCase()} - ${visit.visit_time} - ${moment(visit.visit_date).format("DD-MM-YYYY")} - ${visit.address} ${visit.company}  `}</li>
                              })}</ul>
                              </Message>}
                                <Grid columns={2} className="minTop-margin">
                                    <Grid.Row style={{fontSize: '1.2em', textAlign: 'center'}}>

                                        <Grid.Column>
                                         <div>
                                                <span className="format-bold">Assigned To: </span>
                                               { this.state.clerkOptions ? <Dropdown
                                                search
                                                placeholder="Select Clerk"
                                                selection
                                                options={this.state.clerkOptions}
                                                value={
                                                this.state.selectedClerk}
                                                onChange={(e, { value }) =>{
                                                     let selectedClerkObject = this.state.clerkOptions.find( clerk => clerk.value === value   );
                                                 this.setState({ selectedClerk: value,selectedClerkObject:selectedClerkObject },()=>{this.refreshPVs(),this.checkClerkEndDate()})}
                                                }
                                                style={{ minWidth: "200px" }}
                                                /> : <Button  style={{height:"38px"}} basic compact loading circular></Button>}
                                           {this.state.selectedClerkObject && this.state.selectedClerkObject.end_date && <p><Button style={{marginTop:"5px"}} color="red" compact basic icon="exclamation" 
                                           content={`END DATE: ${moment(this.state.selectedClerkObject.end_date).format("DD-MM-YYYY")}`}
                                           ></Button> </p>}
                                            </div>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <div><span className="format-bold">Status: </span><Button onClick={(e)=>{e.preventDefault()}} color="black" basic 
                                            style={{cursor:"default",height:"38px"}}><span
                                                className="formatcase">{selectedInspection['status']}</span></Button></div>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </div>
                        </div>
                        <Grid stackable columns={2} className="minTop-margin left-aligned" style={{marginTop: '0.5em'}}>
                            <Grid.Row>
                                <Grid.Column>
                                    <Segment style={{height:'100%'}}>
                                        <Label color='blue' ribbon>
                                            Property Details
                                        </Label>
                                        <p></p>
                                        <Grid.Column>
                                            <dl>
                                                <dt>Company Name</dt>
                                                <dd>{selectedInspection['company_name']}</dd>

                                                <dt style={{height: '60px'}}>Address</dt>
                                                <dd>{selectedInspection.property.address}
                                                </dd>
                                            </dl>
                                             <div className="pull-left">
                                            <Form.Group widths={2}>
                                                <Form.Field>
                                                    <label className="required">No. of Bedrooms</label>
                                                </Form.Field>
                                                <Form.Dropdown
                                                    required
                                                    selection
                                                    error={this.state.invalidRoomCount}
                                                    wrapSelection={false}
                                                    options={bedRoomOptions}
                                                    placeholder='No. of bedrooms'
                                                    defaultValue={this.state.inspectionDetails['property_size'].toString()}
                                                    onFocus={()=>this.setState({invalidRoomCount:false})}
                                                    onChange={(e, option) => {
                                                        this.setState({numberOfBedroom: option.value})
                                                    }}
                                                />
                                            </Form.Group>
                                            <Form.Group widths={2}>
                                                <Form.Field>
                                                    <label>Furnishing Type </label>
                                                </Form.Field>
                                                <Form.Dropdown
                                                    required
                                                    selection
                                                    error={this.state.furnishInvalid}
                                                    wrapSelection={false}
                                                    options={furnishOptions}
                                                    placeholder='Furnishing Type'
                                                    defaultValue={furnishing.indexOf(this.state.inspectionDetails['furnishing_type']).toString()}
                                                    onFocus= {()=>this.setState({furnishInvalid:false})}
                                                    onChange={(e, option) => {
                                                        this.setState({furnishingType: option.value})
                                                    }}
                                                />
                                            </Form.Group>
                                            </div>
                                            <div className="pull-left" style={{width:'85%'}}>
                                                <Form.Dropdown
                                                    label='Agent Name'
                                                    required
                                                    search
                                                    disabled={agentAccessRestricted}
                                                    noResultsMessage="Agents not found"
                                                    error={!this.state.agentValid}
                                                    selection
                                                    value={this.state.assignedAgent}
                                                    wrapSelection={false}
                                                    options={this.state.agentListOptions}
                                                    placeholder='Agent Name'
                                                    onFocus={()=>this.setState({agentValid:true})}
                                                    onChange={(e, option) => {
                                                        this.setState({assignedAgent: option.value})
                                                    }}
                                                />
                                            </div>
                                            <Form.Input label="New Reference Id" type="text" name="reference_id" defaultValue={selectedInspection['reference_id']} />
                                        </Grid.Column>
                                    </Segment>
                                </Grid.Column>
                                <Grid.Column className="left-aligned">
                                    <Segment  style={{height:'100%'}}>
                                        <Label color='blue' ribbon>
                                            Inspection Details
                                        </Label>
                                        <p></p>
                                        <Grid.Column>
                                            <Form.Dropdown
                                                label="Inspection Type"
                                                required
                                                selection
                                                disabled={agentAccessRestricted}
                                                wrapSelection={false}
                                                options={jobTypeOptions}
                                                placeholder='CI'
                                                defaultValue={selectedInspection['inspection_type']}
                                                onChange={(e, option) => {
                                                    this.setState({jobType: option.value})
                                                        if(option.value === "co" && this.state.reportType ==="new" || this.state.reportType ==="other" && option.value !== "co"  ) {this.setState({reportType:undefined})}
                                                        if((option.value === "pv" || option.value === "rev" || option.value === "cln")  && this.state.reportType !=="custom" ) {this.setState({reportType:undefined})}
                                                }}
                                            />
                                            <div className='ui field'>
                                                <span className='required field'><label><b>Inspection Date</b>(DD-MM-YYYY):</label></span>
                                                <span className={this.state.dateValid?'field':'field ui error'}>
                                                    <DayPickerInput
                                                        value={moment(selectedInspection['inspection_start_time'], "YYYY-MM-DD HH:mm").format("DD-MM-YYYY")}
                                                        placeholder="DD-MM-YYYY"
                                                        dayPickerProps={{
                                                            todayButton: 'Today',
                                                            firstDayOfWeek : 1,
                                                        }}
                                                        inputProps={{
                                                            disabled:agentAccessRestricted
                                                        }}
                                                        format="DD-MM-YYYY"
                                                        formatDate={formatDate}
                                                        parseDate={parseDate}
                                                        onDayChange={day => {if(day) { this.setState({
                                                            inspectionDate: day,
                                                            dateValid:true,
                                                            inspectionStartTime:moment(day).hour(parseInt(moment(this.state.inspectionStartTime).format("HH"))).minute(parseInt(moment(this.state.inspectionStartTime).format("mm"))).format("YYYY-MM-DD HH:mm"),
                                                            inspectionEndTime:moment(day).hour(parseInt(moment(this.state.inspectionEndTime).format("HH"))).minute(parseInt(moment(this.state.inspectionEndTime).format("mm"))).format("YYYY-MM-DD HH:mm"),
                                                        }
                                                    ,()=>{this.refreshPVs(),this.checkClerkEndDate()})}
                                                        else {
                                                            this.setState({dateValid:false,inspectionDate:undefined});
                                                        }}}
                                                    />
                                                </span>
                                            </div>

                                            <Form.Dropdown
                                                required
                                                selection
                                                error={!this.state.timeValid}
                                                wrapSelection={false}
                                                options={timeOptions}
                                                placeholder='Anytime'
                                                defaultValue={'3'}
                                                disabled={this.props.userRole === 'agent'}
                                                onChange={handleDateRangeSelection}
                                            />{this.state.RequestedTime === '3' &&
                                        <div style={{paddingTop: '10px'}}>
                                            <Form.Group inline>
                                                <TimePicker
                                                    showSecond={false}
                                                    placeholder='08:00'
                                                    value={moment(this.state.inspectionStartTime)}
                                                    className="time-width"
                                                    onChange={this.onStartChange}
                                                    format={timeFormat}
                                                    disabledHours={this.disabledHours}
                                                    hideDisabledOptions={true}
                                                    minuteStep={15}
                                                    disabled={agentAccessRestricted}
                                                    inputReadOnly
                                                /><span>--</span>
                                                <TimePicker
                                                    showSecond={false}
                                                    value={this.state.defaultEndTime}
                                                    placeholder='17:00'
                                                    className="time-width"
                                                    disabledHours={this.disabledHours}
                                                    onChange={this.onEndChange}
                                                    hideDisabledOptions={true}
                                                    format={timeFormat}
                                                    minuteStep={15}
                                                    disabled={agentAccessRestricted}
                                                    inputReadOnly
                                                />
                                            </Form.Group>
                                        </div>
                                        }
                                        </Grid.Column>
                                    </Segment>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                    <Segment  style={{height:'100%'}}>
                                        <Label color='blue' ribbon>
                                            Additional Details
                                        </Label>
                                        <p></p>
                                        <Grid.Column>
                                            <Form.Group widths={2}>
                                                <Form.Input label="Tenant Name" name="tenant_name" type="text"
                                                            defaultValue={selectedInspection['tenant_name']}/>

                                                <Form.Input label="Tenant Contact" name="tenant_contact" type="text"
                                                            defaultValue={selectedInspection['tenant_contact']}/>
                                            </Form.Group>
                                            <Form.Group widths={2}>
                                                <Form.Input label="Get Keys From" name="get_keys_from" type="text"
                                                            defaultValue={selectedInspection['get_keys_from']}/>

                                                <Form.Input label="Return Keys To" name="return_keys_to" type="text"
                                                            defaultValue={selectedInspection['return_keys_to']}/>
                                            </Form.Group>
                                            <Form.Group widths={2}>
                                                <Form.Input label="Send Invoice To" name="send_invoice_to" type="text"
                                                            defaultValue={selectedInspection['send_invoice_to']}/>

                                                <Form.Input label="Send Report To" name="send_report_to" type="text"
                                                            defaultValue={selectedInspection['send_report_to']}/>
                                            </Form.Group>

                                            {this.props.userRole !== 'agent' && <Form.Dropdown
                                                label='Report Type'
                                                required
                                                selection
                                                error={!this.state.reportTypeValid}
                                                wrapSelection={false}
                                                options={this.state.jobType === 'co'? reportTypeOptionsCO:(this.state.jobType ==="pv" || this.state.jobType === "rev" || this.state.jobType === "cln")? reportTypeOptionsPV:reportTypeOptions}
                                                placeholder='Select Report Type'
                                                defaultValue={selectedInspection['report_type']}
                                                onChange={(e, option) => {
                                                    this.setState({reportType: option.value, reportTypeValid:true})
                                                }}
                                                upward
                                            />}
                                            <div style={{ textAlign: "center" }}>
                                                {!this.state.showPropertyDetails ? <Button onClick={(e) => { e.preventDefault();this.setState({ showPropertyDetails: true }); this.getPropertyDetails() }}> Show Property Details</Button>:undefined}</div>
                                        </Grid.Column>
                                    </Segment>
                                </Grid.Column>
                                <Grid.Column className="left-aligned">
                                    <Segment  style={{height:'100%'}}>
                                        <Label color='blue' ribbon>
                                            Invoice Details
                                        </Label>
                                        <p></p>
                                        <Grid.Column>
                                            {/* <Form.Group widths={1}>
                                                <label className="custom-field">Invoice Details:</label>
                                                <Form.Checkbox name="invoice details" label='Default'
                                                               defaultChecked={selectedInspection['default_invoice']}
                                                               onChange={(e, {checked}) => {
                                                                   checked ? this.setState({
                                                                       invoiceIsDefault: true,
                                                                       displayAdditionalInvoiceOption: false
                                                                   }) : this.setState({
                                                                       invoiceIsDefault: false,
                                                                       displayAdditionalInvoiceOption: true
                                                                   })
                                                               }}/>
                                            </Form.Group> */}
                                            {/* {this.state.displayAdditionalInvoiceOption && <div>
                                                <Form.Group widths={2}>
                                                    <Form.Input label="Invoice Name" placeholder='Invoice Name'
                                                                name="invoice_name"
                                                                defaultValue={selectedInspection['invoice_name']} required/>
                                                    <Form.Input label="Invoice Address" placeholder='Invoice Address'
                                                                name="invoice_address"
                                                                defaultValue={selectedInspection['invoice_address']} required/>
                                                </Form.Group>
                                            </div>} */}
                                            <div>
                                                {(this.state.invoiceFeeError || this.state.clerkFeeError) &&<Message size='mini' color="red">Text needs to include either TOTAL or EXTRA to allow discernment of fee type</Message>}
                                                <Form.Group widths={2}>
                                                    <Form.Input label="Clerk Pay/Extra Amount" placeholder='Clerk Travel Charge'
                                                                name="clerk_charge" onChange={e=>{this.checkFeeValidity("clerk",e.target.value)}}
                                                                defaultValue={selectedInspection['clerk_charge']} error={this.state.clerkFeeError}/>
                                                    <Form.Input label="Invoice Price/Extra Amount" placeholder='Invoice Charge'
                                                                name="invoice_charge" onChange={e=>{this.checkFeeValidity("invoice",e.target.value)}}
                                                        defaultValue={selectedInspection['invoice_charge']} error={this.state.invoiceFeeError} />
                                                    <Popup  wide="very"
                                                        trigger={<Icon name="question circle" color="blue"></Icon>}>
                                                        <h2><strong>Extra Charges / Price Syntax </strong></h2>
                                                        <p>Whether for the Clerk Pay or for the Invoice Amount, be sure to indicate whether this refers to an additional amount on top of the clerk pay/invoice or if it refers to the full amount</p>
                                                        <p>Do this by prepending a <strong>+</strong> or <strong>CT</strong> for example, if it is an amount to add on top of the full amount (e.g you can do <strong>+15</strong> to represent adding £15 to clerk pay)</p>
                                                        <p>To specify the full invoice or clerk pay amount, just type the number by itself, or to be more specific you can type something like <strong>£150 FULL PRICE</strong></p>
                                                    </Popup>
                                                </Form.Group>
                                            </div>
                                            <Form.TextArea name="notes" label="Notes"
                                                           defaultValue={selectedInspection['notes'] ? selectedInspection['notes'] : ""}
                                                           onChange={(e) => {
                                                               this.setState({
                                                                   notes: e.target.value,
                                                                   additionalChanged: true
                                                               })
                                                           }}/>
                                            <Form.TextArea name="conclusion_notes" label="Conclusion Notes"
                                                           defaultValue={selectedInspection['conclusion_notes'] ? selectedInspection['conclusion_notes'] : ""}
                                                           onChange={(e) => {
                                                               this.setState({
                                                                   comments: e.target.value,
                                                                   additionalChanged: true
                                                               })
                                                           }}
                                                           disabled={this.props.userRole === 'agent'}
                                            />
                                        </Grid.Column>
                                    </Segment>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        {!this.state.showPropertyDetails ? undefined :<Segment textAlign="center">  { this.state.fetchingPropertyDetails ? <Button loading > Loading </Button> : <ViewPropertyDetails userRole={this.props.userRole} disableMerge={true} selectedObject={[this.state.propertyDetails]}/>}</Segment>}
                        <Message negative>Please ensure that any invoice requests for smoke / carbon alarm installations, private invoices or any other extra charges requiring additional invoices to be created are emailed to accounts@hinchpm.com, it is not sufficient to just leave a "INV?" in the notes field as this is very likely to be missed especially if a client is invoiced monthy.</Message>
                        <div style={{paddingTop: '2%'}} className="pad-bottom">
                            <Segment  className="left-aligned">
                                <Label color='blue' ribbon>
                                    Inspection Attachments
                                </Label>
                                <p></p>
                                {this.state.maxNumberOfFilesExceeded &&
                                <p><span className="error-message">Max number of allowed files is 3</span></p>}
                                <DropzoneComponent config={componentConfig}
                                                   eventHandlers={eventHandlers}
                                                   djsConfig={djsConfig}/>
                            </Segment>
                        </div>
                        {this.state.infoMessage &&
                        <div className="pad-all"><Message header={this.state.infoMessage} info
                                                          onDismiss={() => {
                                                              this.setState({infoMessage: undefined})
                                                          }}/></div>}
                        <div className="submit-buttons">
                            <Button type="submit" primary disabled={this.state.invoiceFeeError || this.state.clerkFeeError} content="Update Inspection"/>
                        </div>
                    </Segment>}
                </Form>
            </div>
        );
    }
}

export default InspectionContainer(UpdateInspection);


// WEBPACK FOOTER //
// ./src/views/inspection/update_inspection.js